import './SupportActionFeed.scss';
import { CloseButton } from '@mantine/core';
import type { IRemoteActionEntry } from '@srm/screen-sharing/light';

/** Запись ленты: `id` — стабильный ключ, пока лента обрезается до последних записей. */
export interface ISupportActionFeedEntry extends IRemoteActionEntry {
    id: number;
}

export interface ISupportActionFeedProps {
    /** Действия сотрудника в кабинете — те же, что запишутся в журнал сеанса */
    entries: ISupportActionFeedEntry[];
    onClose: () => void;
}

const time = (at: string) => {
    const date = new Date(at);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

/**
 * Лента действий поддержки под полосой показа: «14:02 Нажал «Редактировать»». Не модальная: фокус не забирает, а
 * сотрудник продолжает работать, пока пользователь читает.
 */
const SupportActionFeed = ({ entries, onClose }: ISupportActionFeedProps) => (
    <section className="support-action-feed" aria-label="Действия поддержки" data-testid="support-action-feed">
        <header className="support-action-feed__header">
            <h4>Действия поддержки</h4>
            <CloseButton size={24} iconSize={16} aria-label="Скрыть действия" onClick={onClose} />
        </header>
        {entries.length ? (
            <ol className="support-action-feed__list" aria-live="polite">
                {entries.map((entry) => (
                    <li key={entry.id}>
                        <time dateTime={entry.at}>{time(entry.at)}</time>
                        <span>{entry.text}</span>
                    </li>
                ))}
            </ol>
        ) : (
            <p className="support-action-feed__empty">Пока ничего не нажато</p>
        )}
    </section>
);

export default SupportActionFeed;
